import React from 'react';
import { Button } from '@material-ui/core';
import { useForm, useFormState } from 'react-final-form';
import HistoryIcon from '@material-ui/icons/History';

function ResetButton(props) {
    const form = useForm();
    const { submitting, pristine } = useFormState({
        subscription: { submitting: true, pristine: true },
    });

    return (
        <Button
            variant="contained"
            type="button"
            onClick={() => form.reset()}
            disabled={submitting || pristine}
            startIcon={<HistoryIcon />}
            {...props}
        />
    );
}

ResetButton.defaultProps = {
    children: 'Atstatyti',
    disableElevation: true,
};

export default React.memo(ResetButton);
